/* eslint-disable import/prefer-default-export */
import { all, call, put, select } from 'redux-saga/effects'
import firebase from '../config/firebase'
import DashboardActions from '../reducers/dashboardReducer'

import utils from '../utils'

export function* getExpressOrders({ startAt, endAt }) {
  try {
    const ref = firebase
      .firestore()
      .collection('express_orders')
      .where('created_at', '>=', Number(startAt))
      .where('created_at', '<=', Number(endAt))

    const snapshot = yield call([ref, ref.get])
    const expressOrders = []

    snapshot.forEach(doc => {
      expressOrders.push({ ...doc.data(), id: doc.id })
    })

    yield put(DashboardActions.setExpressOrders(expressOrders))
  } catch (error) {
    yield put(DashboardActions.setExpressOrderError(error))
  }
}

export function* getOrderByDate({ start, end }) {
  try {
    const orderRef = firebase
      .database()
      .ref('orders')
      .orderByChild('created_at')
      .startAt(start)
      .endAt(end)

    const { region } = yield select(state => state.auth.data)
    const response = yield call([orderRef, orderRef.once], 'value')
    let orders = response.val()

    if (orders !== null) {
      orders = utils.order.filterByRegion(orders, region)
      yield put(DashboardActions.getOrderByDateSuccess(orders))
    } else {
      yield put(DashboardActions.getOrderByDateSuccess({}))
    }
  } catch (error) {
    yield put(DashboardActions.getOrderByDateFailure(error))
  }
}

export function* getPayingCustomers() {
  try {
    const activationRef = firebase
      .database()
      .ref('deliverees')
      .orderByChild('delivered_order_count')
      .equalTo(1)

    const retentionRef = firebase
      .database()
      .ref('deliverees')
      .orderByChild('delivered_order_count')
      .startAt(2)

    const [activationCustomers, retentionCustomers] = yield all([
      call([activationRef, activationRef.once], 'value'),
      call([retentionRef, retentionRef.once], 'value'),
    ])

    if (activationCustomers.val()) {
      yield put(DashboardActions.getPayingCustomersSuccess('activation', activationCustomers.val()))
    } else {
      yield put(DashboardActions.getPayingCustomersSuccess('activation', {}))
    }

    if (retentionCustomers.val()) {
      yield put(DashboardActions.getPayingCustomersSuccess('retention', retentionCustomers.val()))
    } else {
      yield put(DashboardActions.getPayingCustomersSuccess('retention', {}))
    }
  } catch (error) {
    yield put(DashboardActions.getPayingCustomersSuccess('activation', {}))
    yield put(DashboardActions.getPayingCustomersSuccess('retention', {}))
  }
}

export function* getCustomersByDate({ startAt, endAt }) {
  try {
    yield put(DashboardActions.setDashboardCustomerLoading(true))
    const customerRef = firebase
      .database()
      .ref('deliverees')
      .orderByChild('created_at')
      .startAt(startAt)
      .endAt(endAt)
    const snapshot = yield call([customerRef, customerRef.once], 'value')
    const { region } = yield select(state => state.auth.data)
    let customers = snapshot.val()

    if (customers) {
      customers = utils.customer.filterByRegion(customers, region)
      yield put(DashboardActions.setDashboardCustomers(customers))
    } else {
      yield put(DashboardActions.setDashboardCustomers({}))
    }

    yield put(DashboardActions.setDashboardCustomerLoading(false))
  } catch (error) {
    yield put(DashboardActions.setDashboardCustomerLoading(false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/dashboardSaga.js